
export const useEmailValidation = () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  function validateEmail(email: string): { isValid: boolean; error: string | null } {
    if (!email) {
      return { isValid: false, error: "E-posti aadress on kohustuslik" };
    }
    if (!emailRegex.test(email)) {
      return { isValid: false, error: "Palun sisesta korrektne e-posti aadress" };
    }
    return { isValid: true, error: null };
  }
  
  return { validateEmail };
};
